export enum PrognosisType {
  AXIAL_LENGTH = 0,
  SPHERICAL_EQUIVALENT = 1
}

export enum MyopiaPrognosisType {
  BLOOM_DAY = 0,
  BLOOM_NIGHT = 1
}
